import createReactClass from "create-react-class";
import update from "immutability-helper";
import React from "react";
import { Button } from "react-bootstrap";
import DateTime from "react-datetime";
import _ from "underscore";
import { ErrorAction } from "../actions/errorActions";
import { FormRequestActions } from "../actions/formRequestActions";
import { ServerActions } from "../actions/serverActions";
import { ConfirmationModalActions } from "../actions/submissionConfirmationModalActions";
import { TabActions } from "../actions/tabActions";
import { FormCPatternModal } from "../components/formCPatternModal";
import { InformationRadiatorView } from "../components/informationRadiator";
import { ModalError } from "../components/modalError";
import { SubdivisionLocationList } from "../components/subdivisionLocationList";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { subdivisionStore } from "../stores/subdivision";
import { userStore } from "../stores/user";
import { formValidation as FormBValidator } from "../util/formValidation";
import { SubmissionConfirmationModal } from "./submissionConfirmationModal";

const { ActionTypes } = Constants;
var STATUS = Constants.RestrictionStatuses;
var TYPES = Constants.RestrictionTypes;

function getStateFromStores() {
  return {
    restriction: restrictionRequestStore.getForm(),
    isModifying: restrictionRequestStore.isModifying(),
    isDirty: restrictionRequestStore.isDirty(),
    readOnly: restrictionRequestStore.getReadOnly(),
    partialReadOnly: restrictionRequestStore.getPartialReadOnly(),
    errors: restrictionRequestStore.getErrors(),
    touchedFields: restrictionRequestStore.getTouchedFields(),
    formType: restrictionRequestStore.getFormType(),
    user: userStore.getSelectedRole(),
    printLata: userStore.getLata(),
    clickedItem: subdivisionStore.getSelectedSub(),
    showSubDropDown: restrictionRequestStore.getShowSubDropDown(),
    textValue: "",
    subdivisionSelected: subdivisionStore.isSubSelected(),
    subData: subdivisionStore.getFormCSubData(),
    selectableSubList: subdivisionStore.getSubList(),
    divisions: subdivisionStore.getDivList(),
    entireSubList: subdivisionStore.getEntireSubList(),
    previousSub: "",
    showFromLocations: restrictionRequestStore.getShowFormCFromLocations(),
    fromLocationSuggestion: restrictionRequestStore.getFromLocationSuggestion(),
    showToLocations: restrictionRequestStore.getShowFormCToLocations(),
    toLocationSuggestion: restrictionRequestStore.getToLocationSuggestion(),
    disableMps: restrictionRequestStore.getDisableFormCMps(),
    disableLocations: restrictionRequestStore.getDisableFormCLocations(),
    disableSubSelection: restrictionRequestStore.getDisableFormCSubSelection(),
    disableEntireSub: restrictionRequestStore.getDisableFormCEntireSub(),
    disableAllSubs: restrictionRequestStore.getDisableFormCAllSubs(),
    mpTitle: restrictionRequestStore.getFormCMpTitle(),
    locTitle: restrictionRequestStore.getFormCLocTitle(),
    subSelectionTitle: restrictionRequestStore.getFormCSubDropDownTitle(),
    entireSubTitle: restrictionRequestStore.getFormCEntireSubTitle(),
    entireSubChecked: restrictionRequestStore.getFormCEntireSubChecked(),
  };
}

export const FormCFormView = createReactClass({
  componentDidMount: function () {
    restrictionRequestStore.subscribe(this._onChange);
    subdivisionStore.subscribe(this._onChange);
    userStore.subscribe(this._onChange);
    document.addEventListener("mousedown", this.handleClickOutside);
  },

  componentWillUnmount: function () {
    restrictionRequestStore.unsubscribe(this._onChange);
    subdivisionStore.unsubscribe(this._onChange);
    userStore.unsubscribe(this._onChange);
    document.removeEventListener("mousedown", this.handleClickOutside);
  },

  handleClickOutside: function (event) {
    if (this.state.showSubDropDown) {
      var targetId = event.target.id;
      if (targetId === "issueRequest") {
        return;
      }
      if (
          targetId &&
          (targetId === "dropDown" ||
              targetId === "dropDownSelect" ||
              targetId === "dropDownUl" ||
              targetId === "userSelect")
      ) {
        return;
      }
      var className = event.target.className;
      if (
          className &&
          (className.indexOf("licustom") > -1 ||
              className.indexOf("dateInput") > -1 ||
              className.indexOf("rdt") > -1)
      ) {
        return;
      }

      if (
          event.currentTarget.activeElement.className === "dateInput" ||
          className === "rdtSwitch" ||
          className === "rdtYear" ||
          className === "rdtMonth" ||
          (event.path !== undefined &&
              event.path[8] !== undefined &&
              event.path[8].id === "expectDate")
      ) {
        return;
      }

      FormRequestActions.toggleShowSubDropDown(false);
    }
  },
  changeEntireSub: function (event) {
    var checkedValue = event.target.checked;
    let fromMp = 0;
    let toMp = 0;
    let fromSfx = "";
    let toSfx = "";
    if (checkedValue && this.state.subData.milePostRangeList.length !== 0) {
      let mpList = [];
      //Get a list of all of the MPs with their sequence numbers
      _.map(this.state.subData.milePostRangeList, function (range) {
        mpList.push({ mp: range.from, sfx: range.sfx, seqNum: range.seqLow });
        mpList.push({ mp: range.to, sfx: range.sfx, seqNum: range.seqHigh });
      });

      //Sort from low to high sequence numbers
      mpList = _.sortBy(mpList, "seqNum");

      //FromMP is the lowest sequence, toMp is the highest. That is how they will appear on the form
      fromMp = mpList[0].mp;
      if (mpList[0].sfx !== null) {
        fromSfx = mpList[0].sfx;
      }
      toMp = mpList[mpList.length - 1].mp;
      if (mpList[mpList.length - 1].sfx !== null) {
        toSfx = mpList[mpList.length - 1].sfx;
      }
    }

    dispatcher.dispatch({
      type: ActionTypes.CHANGED_SELECT_ENTIRE_SUB,
      entireSub: checkedValue,
      fromMp: fromMp,
      fromSfx: fromSfx,
      toMp: toMp,
      toSfx: toSfx,
    });
  },

  changeSelectAllSub: function () {
    FormRequestActions.formCSubdivisionSelection("ALL");
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  getInitialState: function () {
    let newState = getStateFromStores();
    newState.subSelectionTitle =
      "Clear Location/MP values to select multiple subdivisions";
    return newState;
  },

  getFormattedDate: function (date) {
    var dateVal =
      ("0" + (parseInt(date.getMonth()) + 1)).slice(-2) +
      ("0" + date.getDate()).slice(-2) +
      date.getFullYear().toString().substr(2, 2);
    return dateVal;
  },

  deleteSub: function (e) {
    let index = e.target.id;
    const sub = this.state.restriction.subdivisions[index];
    FormRequestActions.formCSubdivisionSelection(sub);

    if (this.state.restriction.subdivisions.length === 1) {
      //If there is only one sub, get the sub details
      ServerActions.getFormCSubdivisionDetails(
        this.state.restriction.subdivisions[0]
      );
    }
  },
  changeText: function (e) {
    FormRequestActions.formCTextChanged(e.target.value);
  },
  changeTextFromPattern: function (text) {
    FormRequestActions.formCTextChanged(text);
  },
  voidRestriction: function () {
    var state = this.state;
    const title = "Confirm Void of " + state.restriction.controlNumber;
    const body =
      "Are you sure you want to void restriction " +
      state.restriction.controlNumber +
      "?";
    if (this.state.isDirty && this.state.formType === TYPES.C) {
      ErrorAction.showModalError(
        "Values on the restriction have been modified. Please reload the form to void"
      );
    } else {
      window
        .confirm(title, {
          description: body,
          confirmLabel: "Void",
          abortLabel: "Go Back",
        })
        .then(function () {
          ServerActions.submitItemToServer({
            action: Constants.restrictionActions.VOID_RESTRICTION,
            printLata: state.printLata,
            id: state.restriction.requestId,
            requestToSubmit:
              restrictionRequestStore.restrictionFormattedForSubmission(),
          });
        });
    }
  },
  updateFormC: function () {
    ServerActions.submitItemToServer({
      action: Constants.restrictionActions.MODIFY_RESTRICTION,
      printLata: this.state.printLata,
      requestToSubmit:
        restrictionRequestStore.restrictionFormattedForSubmission(),
    });
  },

  formCDT: function () {
    ServerActions.submitItemToServer({
      action: Constants.restrictionActions.FORMCDT_RESTRICTION,
      printLata: this.state.printLata,
      requestToSubmit:
        restrictionRequestStore.restrictionFormattedForSubmission(),
    });
  },

  onSubSelectChange: function (event) {
    this.setState({ clickedItem: event });

    if (this.state.restriction.status === STATUS.ISSUED) {
      //Special handling for modifying MULTIs or ALLs
      if (
        this.state.restriction.subdivision === "MULTI" &&
        this.state.restriction.subdivisions.length === 2 &&
        this.state.restriction.subdivisions.indexOf(event) > -1
      ) {
        ErrorAction.showModalError(
          "MULTI subdivision restrictions must have at least two subdivisions"
        );
      } else {
        FormRequestActions.formCSubdivisionSelection(event);
      }
    } else {
      FormRequestActions.formCSubdivisionSelection(event);
    }

    if (this.state.restriction.subdivisions.length === 1) {
      //If there is only one sub, get the sub details
      ServerActions.getFormCSubdivisionDetails(
        this.state.restriction.subdivisions[0]
      );
    }
  },

  onDivSelectChange: function (event) {
    //FormRequestActions.formCDivisionSelection(event);
    //Enable to select multiple divisions
    var subDivs = event.subdivisions;
    for (var i = 0; i < subDivs.length; i++) {
      var index = this.state.restriction.subdivisions.indexOf(subDivs[i]);
      if (index <= -1) {
        FormRequestActions.formCSubdivisionSelection(subDivs[i]);
      }
    }
    // this.setState({clickedItem: event});
    //
    // if (this.state.restriction.status === STATUS.ISSUED) {
    //     //Special handling for modifying MULTIs or ALLs
    //     if (this.state.restriction.subdivision === "MULTI" && this.state.restriction.subdivisions.length === 2 && this.state.restriction.subdivisions.indexOf(event) > -1) {
    //         ErrorAction.showModalError("MULTI subdivision restrictions must have at least two subdivisions");
    //     } else {
    //         FormRequestActions.formCSubdivisionSelection(event);
    //     }
    //
    // } else {
    //     FormRequestActions.formCSubdivisionSelection(event);
    // }
    //
    // if (this.state.restriction.subdivisions.length === 1) {
    //     //If there is only one sub, get the sub details
    //     ServerActions.getFormCSubdivisionDetails(this.state.restriction.subdivisions[0])
    // }
  },

  showSubDropDown: function () {
    if (!(this.state.disableSubSelection || this.state.readOnly || this.state.partialReadOnly))
      this.toggleShowSubDropDown(true);
  },
  hideSubDropDown: function () {
    this.toggleShowSubDropDown(false);
  },
  toggleShowSubDropDown: function (value) {
    FormRequestActions.toggleShowSubDropDown(value);
  },
  clearForm: function () {
    window
      .confirm("Clear", {
        description:
          "Selecting Clear will abandon all your current work. Are you sure you want to do this?",
        confirmLabel: "Clear",
        abortLabel: "Go Back",
      })
      .then(function () {
        FormRequestActions.reset();
      });
  },
  backToIssueList: function () {
    if (this.state.isDirty) {
      window
        .confirm("Return to Issue List", {
          description:
            "Selecting Issue List will abandon all your current work and return you to the restriction list. Are you sure you want to do this?",
          confirmLabel: "Issue List",
          abortLabel: "Go Back",
        })
        .then(function () {
          TabActions.changeTab(1, "c");
        });
    } else {
      TabActions.changeTab(1, "c");
    }
  },
  handleMouseDown: function (event) {
    event.preventDefault();
  },
  setText(selectedPatterns) {
    if (selectedPatterns) {
      let pattCommentText = [];
      selectedPatterns.map((item) => {
        pattCommentText.push(item.lineText);
      });

      this.changeTextFromPattern(pattCommentText.join("\n").replace(/\n$/, ""));
    }
  },
  renderChip: function (that) {
    var selectedValues;
    var formcflag = "X";
    let subHover = "";
    if (
      that.state.user.indexOf(Constants.Roles.FIELD_USER) === 0 ||
      this.state.disableSubSelection
    ) {
      formcflag = "";
    }

    if (this.state.restriction.status === STATUS.ISSUED) {
      //Special handling for modifying MULTIs or ALLs
      if (
        this.state.restriction.subdivision === "MULTI" &&
        this.state.restriction.subdivisions.length === 2
      ) {
        formcflag = "";
        subHover =
          "MULTI subdivision restrictions must have at least two subdivisions";
      }

      if (this.state.restriction.subdivision === "ALL") {
        formcflag = "";
        subHover =
          "ALL subdivisions restrictions subdivisions can't be modified";
      }
    }
    if (this.state.restriction.subdivisions) {
      selectedValues = this.state.restriction.subdivisions.map(
        function (sub, i) {
          return (
            <div
              key={i}
              style={{
                backgroundColor: "white",
                padding: "2px",
                width: "150px",
              }}
              title={subHover}
            >
              {" "}
              {sub}
              <i
                key={i}
                id={i}
                style={{
                  color: "black",
                  cursor: "pointer",
                  float: "right",
                }}
                onClick={this.deleteSub}
              >
                {formcflag}
              </i>
            </div>
          );
        }.bind(this)
      );
    }
    return selectedValues;
  },
  onChange: function (event) {
    let regex = /^[\s\S]+$/;
    if (
      event.target.id === "workStartMpSuffix" ||
      event.target.id === "workEndMpSuffix"
    ) {
      regex = /^[a-zA-Z\b]+$/;
    } else if (
      event.target.id === "workStartMp" ||
      event.target.id === "workEndMp"
    ) {
      regex = /^[0-9.\b]+$/;
    }
    if (event.target.value === "" || regex.test(event.target.value)) {
      var target = event.target.id;
      var vals = {};
      vals[target] = { $set: event.target.value.toUpperCase() };
      var newState = update(this.state, {
        restriction: vals,
      });
      this.setState(newState);

      FormRequestActions.formFieldChanged(newState.restriction, target);
    }
  },
  updateDateState: function (fieldName, event) {
    var vals = {};

    var dateVal;
    if (event._d !== undefined) {
      dateVal = this.getFormattedDate(event._d);
    } else {
      dateVal = event;
    }
    vals[fieldName] = { $set: dateVal };
    var newState = update(this.state, {
      restriction: vals,
    });
    this.setState(newState);
    FormRequestActions.dateFieldChanged(
      this.state.restriction,
      fieldName,
      dateVal
    );
    FormRequestActions.formFieldBlurred(this.state.restriction, fieldName);
  },

  onExpireDateChange: function (event) {
    this.updateDateState("estimatedRemovalDate", event);
  },

  onEstRemovalBlur: function (event) {
    this.updateDateState("estimatedRemovalDate", event);
  },

  onEstRemovalFocus: function () {
    setTimeout(function () {
      $("#expectDate .dateInput").blur();
      $("#expectDate .dateInput").focus();
    }, 10);
  },
  onLocationChange: function (event) {
    if (event.target.value || event.target.value === "") {
      var target = event.target.id;
      var vals = {};
      vals[target] = { $set: event.target.value.toUpperCase() };
      var newState = update(this.state, {
        restriction: vals,
      });
      this.setState(newState);

      FormRequestActions.formFieldChanged(newState.restriction, target);
    }
  },
  onFromLocationFocus: function () {
    if (this.state.restriction.subdivisions.length === 1) {
      let locations = restrictionRequestStore.getSubLocations();
      if (locations && locations.length === 0) {
        //If there are no location, get them from the server
        FormRequestActions.requestSubdivisionLocations(
          this.state.restriction.subdivisions[0]
        );
      }
      FormRequestActions.toggleShowFormCFromLocations(true);
    }
    FormRequestActions.toggleShowFormCToLocations(false);
    this.hideSubDropDown();
  },
  onToLocationFocus: function () {
    if (this.state.restriction.subdivisions.length === 1) {
      let locations = restrictionRequestStore.getSubLocations();
      if (locations && locations.length === 0) {
        //If there are no location, get them from the server
        FormRequestActions.requestSubdivisionLocations(
          this.state.restriction.subdivisions[0]
        );
      }
      FormRequestActions.toggleShowFormCToLocations(true);
    }
    FormRequestActions.toggleShowFormCFromLocations(false);
    this.hideSubDropDown();
  },
  onBlur: function (e) {
    FormRequestActions.formFieldBlurred(this.state.restriction, e.target.id);
  },
  onFromLocationBlur: function (e) {
    let target = e.relatedTarget;

    if (target === null) {
      target = document.activeElement;
    }
    if (target.parentElement.id === "locationTable") {
      //No-op. If this is a child of locatonTable, the user is clicking on a location in the list
    } else {
      FormRequestActions.toggleShowFormCFromLocations(false);
      FormRequestActions.formFieldBlurred(
        this.state.restriction,
        "fromLocation"
      );
    }
  },

  onToLocationBlur: function (e) {
    let target = e.relatedTarget;

    if (target === null) {
      target = document.activeElement;
    }
    if (target.parentElement.id === "locationTable") {
      //No-op. If this is a child of locatonTable, the user is clicking on a location in the list
    } else {
      FormRequestActions.toggleShowFormCToLocations(false);
      FormRequestActions.formFieldBlurred(this.state.restriction, "toLocation");
    }
  },

  onInputFocus: function () {
    FormRequestActions.toggleShowFormCFromLocations(false);
    FormRequestActions.toggleShowFormCToLocations(false);
    this.hideSubDropDown();
  },

  issueFormC: function () {
    var canSubmit = restrictionRequestStore.formValid();
    if (!canSubmit) {
      ConfirmationModalActions.validateBeforeSubmitting();
    } else {
      ServerActions.submitItemToServer({
        action: Constants.restrictionActions.ISSUE_RESTRICTION,
        printLata: this.state.printLata,
        requestToSubmit:
          restrictionRequestStore.restrictionFormattedForSubmission(),
      });
    }
  },

  render: function () {
    let restriction = this.state.restriction;
    let isReadOnly = this.state.readOnly;
    let disableMps = this.state.disableMps;
    let disableLocations = this.state.disableLocations;
    let disableSubSelection = this.state.disableSubSelection;
    let disableEntire = this.state.disableEntireSub;
    let disableAll = this.state.disableAllSubs;
    let disableSubmit = false;
    let showFromLocations = this.state.showFromLocations;
    let fromSuggestion = this.state.fromLocationSuggestion;
    let showToLocations = this.state.showToLocations;
    let toSuggestion = this.state.toLocationSuggestion;
    let validRanges = determineValidRanges(this.state.subData);
    let allSubsSelected = false;
    let restrictionText = this.state.restriction.comments;
    let isFieldUser = false;
    let formCDtChangeComment = "";
    let showRanges = true;
    let disableSubDelete = false;

    //Check if they are read only
    if (this.state.user.indexOf(Constants.Roles.READ_ONLY) === 0) {
      isReadOnly = true;
    }

    if (this.state.user.indexOf(Constants.Roles.FIELD_USER) === 0) {
      isFieldUser = true;
      disableSubDelete = true;
      if (
        restriction.formCDTChangeComment !== "" &&
        restriction.formCDTChangeComment !== undefined &&
        restriction.formCDTChangeComment !== null
      )
        formCDtChangeComment =
          "FormCDT Change Comment: " + restriction.formCDTChangeComment;
    }
    if (this.state.restriction.comments) {
      let sortedText = this.state.restriction.comments.sort(function (c1, c2) {
        return sortFunction(c1, c2);
      });

      let text = sortedText.map(function (line) {
        return line.comment;
      });

      restrictionText = text.join("\n");
    }
    if (
      restriction.subdivisions &&
      restriction.subdivisions.indexOf("ALL") > -1
    ) {
      allSubsSelected = true;
      showRanges = false;
    }

    if (restriction.subdivisions && restriction.subdivisions.length > 1) {
      showRanges = false;
    }
    var patternModal = (
      <div>
        <FormCPatternModal setText={this.setText} />
      </div>
    );
    var fromMP = (
      <div className={"topRow"}>
        <label>*From MP:</label>
        <br />
        <input
          type="text"
          disabled={isReadOnly || disableMps || isFieldUser}
          id="workStartMp"
          className="mpInput"
          name="fromMp"
          placeholder="xxxx.x"
          title={disableMps ? this.state.mpTitle : ""}
          value={restriction.workStartMp}
          onFocus={this.hideSubDropDown}
          onChange={this.onChange}
          onBlur={this.onBlur}
          pattern={FormBValidator.regex.mpRegex}
          maxLength="6"
          required
        />
        <input
          type="text"
          disabled={isReadOnly || disableMps || isFieldUser}
          title={disableMps ? this.state.mpTitle : ""}
          id="workStartMpSuffix"
          name="fromMpSuffix"
          className="suffixInput"
          value={restriction.workStartMpSuffix}
          onChange={this.onChange}
          onBlur={this.onBlur}
          pattern={FormBValidator.regex.suffixRegex}
          maxLength="1"
        />
        <span
          className="glyphicon glyphicon-question-sign"
          title={showRanges ? validRanges : ""}
        />
      </div>
    );
    var toMP = (
      <div className={"topRow"}>
        <label>*To MP:</label>
        <br />
        <input
          type="text"
          disabled={isReadOnly || disableMps || isFieldUser}
          id="workEndMp"
          className="mpInput"
          placeholder="xxxx.x"
          title={disableMps ? this.state.mpTitle : ""}
          name="toMp"
          value={restriction.workEndMp}
          onChange={this.onChange}
          onBlur={this.onBlur}
          pattern={FormBValidator.regex.mpRegex}
          maxLength="6"
          required
        />
        <input
          type="text"
          disabled={isReadOnly || disableMps || isFieldUser}
          title={disableMps ? this.state.mpTitle : ""}
          id="workEndMpSuffix"
          name="toMpSuffix"
          value={restriction.workEndMpSuffix}
          onChange={this.onChange}
          onBlur={this.onBlur}
          className="suffixInput"
          maxLength="1"
          pattern={FormBValidator.regex.suffixRegex}
        />
      </div>
    );

    let displayFromLocations = "none";
    if (showFromLocations) {
      displayFromLocations = "";
    }

    var fromLocation = (
      <div id="fromLocationFormC" className={"topFromToAuthorized"}>
        <label>From Location:</label>
        <br />
        <div>
          <input
            type="text"
            value={fromSuggestion}
            disabled={isReadOnly || disableLocations || isFieldUser}
            className="locationInput"
            id="fromLocationSuggestion"
            tabIndex="-1"
          />
          <input
            type="text"
            disabled={isReadOnly || disableLocations || isFieldUser}
            title={disableLocations ? this.state.locTitle : ""}
            value={restriction.fromLocation}
            onChange={this.onLocationChange}
            onBlur={this.onFromLocationBlur}
            onFocus={this.onFromLocationFocus}
            id="fromLocation"
            className="locationInput"
            name="fromLocation"
            maxLength="20"
            required
          />
        </div>
        <div
          id="subdivisionLocations"
          style={{ display: displayFromLocations }}
        >
          <SubdivisionLocationList locationType="from" />
        </div>
      </div>
    );

    let displayToLocations = "none";
    if (showToLocations) {
      displayToLocations = "";
    }
    var toLocation = (
      <div id="toLocationFormC" className={"topFromToAuthorized"}>
        <label>To Location:</label>
        <br />
        <div>
          <input
            type="text"
            value={toSuggestion}
            disabled={isReadOnly || disableLocations || isFieldUser}
            className="locationInput"
            id="toLocationSuggestion"
            tabIndex="-1"
          />
          <input
            type="text"
            disabled={isReadOnly || disableLocations || isFieldUser}
            title={disableLocations ? this.state.locTitle : ""}
            value={restriction.toLocation}
            onChange={this.onLocationChange}
            onBlur={this.onToLocationBlur}
            onFocus={this.onToLocationFocus}
            id="toLocation"
            className="locationInput"
            name="toLocation"
            maxLength="20"
            required
          />
        </div>
        <div id="subdivisionLocations" style={{ display: displayToLocations }}>
          <SubdivisionLocationList locationType="to" />
        </div>
      </div>
    );

    var authorizedBy = (
      <div className={"topFromToAuthorized"}>
        <label>Authorized By* :</label>
        <br />
        <input
          type="text"
          disabled={isReadOnly || isFieldUser}
          onFocus={this.onInputFocus}
          value={restriction.authorizedBy}
          onChange={this.onChange}
          onBlur={this.onBlur}
          id="authorizedBy"
          className="requestedInput"
          name="authorizedBy"
          maxLength="22"
          required
        />
      </div>
    );

    var estimatedRemoval = (
      <div className={"topFromToAuthorized"}>
        <label>Est Removal* :</label>
        <br />
        <div title={formCDtChangeComment} id="expectDate">
          <DateTime
            type="text"
            value={restriction.estimatedRemovalDate}
            id="estimatedRemovalDate"
            ref="estimatedRemovalDate"
            dateFormat="MMDDYY"
            timeFormat={false}
            closeOnSelect={true}
            onFocus={this.onEstRemovalFocus}
            onChange={this.onExpireDateChange}
            onBlur={this.onEstRemovalBlur}
            inputProps={{
              placeholder: "MMDDYY",
              disabled: isReadOnly,
              className: "dateInput",
            }}
          />
        </div>
      </div>
    );

    function renderIssueButton(that) {
      let button = "";
      if (that.state.restriction.status === STATUS.ISSUED) {
        if (that.state.user.indexOf(Constants.Roles.DISPATCHER) > -1) {
          button = (
            <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
              <span>
                <SubmissionConfirmationModal
                  buttonText={"Modify Restriction"}
                  submitAction={that.updateFormC}
                  form={restriction}
                  disabled={!that.state.isDirty}
                  question={
                    "modify restriction " + that.state.restriction.controlNumber
                  }
                  modified={that.state.isDirty}
                  read={{ only: that.state.isReadOnly }}
                />
              </span>
              <span>{patternModal}</span>
            </div>
          );
        } else if (isFieldUser) {
          button = (
            <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
              <span>
                <SubmissionConfirmationModal
                  buttonText={"Modify Restriction"}
                  submitAction={that.formCDT}
                  form={restriction}
                  disabled={!that.state.isDirty}
                  question={
                    "modify restriction " + that.state.restriction.controlNumber
                  }
                  modified={that.state.isDirty}
                  read={{ only: that.state.isReadOnly }}
                />
              </span>
            </div>
          );
        } else {
          button = "";
        }
      } else {
        button = (
          <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
            <span>
              <SubmissionConfirmationModal
                buttonText={"Issue Restriction"}
                submitAction={that.issueFormC}
                form={restriction}
                disabled={disableSubmit}
                question={"issue this restriction"}
                modified={that.state.isDirty}
                read={{ only: false, partial: false }}
              />
            </span>
            <span>{patternModal}</span>
          </div>
        );
      }

      return button;
    }

    function renderResetButton(that) {
      let button = "";

      if (isFieldUser || that.state.restriction.status === STATUS.ISSUED) {
        button = (
          <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
            <Button
              bsStyle="warning"
              id="resetButton"
              onClick={that.backToIssueList}
            >
              Back
            </Button>
          </div>
        );
      } else {
        button = (
          <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
            <Button bsStyle="warning" id="resetButton" onClick={that.clearForm}>
              Clear
            </Button>
          </div>
        );
      }

      return button;
    }

    let selectAll = "";
    if (this.state.user.indexOf(Constants.Roles.ADMIN) > -1) {
      selectAll = (
        <label>
          <input
            type="checkbox"
            disabled={isReadOnly || disableAll || isFieldUser}
            checked={allSubsSelected}
            id="selectAllSubs"
            name="selectAllSubs"
            title="Select all Subs"
            onChange={this.changeSelectAllSub}
          />
          SELECT ALL SUBS
        </label>
      );
    }

    var renderChip = this.renderChip(this);

    var me = this;

    let infoRad = "infoRadShown";
    var liItems = "";
    if (
      this.state.entireSubList &&
      this.state.divisions &&
      restriction.subdivisions
    ) {
      let list = this.state.entireSubList.concat(this.state.divisions);
      liItems = list.map(function (sub, i) {
        if (sub.subdivisions === undefined) {
          if (restriction.subdivisions.indexOf(sub.name) > -1) {
            return (
              <li
                style={{ cursor: "context-menu" }}
                key={i + 1}
                value={sub.name}
                className="licustom darkCss"
                onClick={() => me.onSubSelectChange(sub.name)}
              >
                {sub.name}
              </li>
            );
          } else {
            return (
              <li
                style={{ cursor: "context-menu" }}
                key={i + 1}
                value={sub.name}
                onClick={() => me.onSubSelectChange(sub.name)}
                className="licustom"
              >
                {sub.name}
              </li>
            );
          }
        } else {
          return (
            <li
              style={{ cursor: "context-menu" }}
              key={i + 1}
              value={sub.name}
              onClick={() => me.onDivSelectChange(sub)}
              className="licustom"
            >
              {sub.name}
            </li>
          );
        }
      });
    }
    function voidRestricionButton(that) {
      if (that.state.restriction.status === STATUS.ISSUED) {
        if (that.state.user.indexOf(Constants.Roles.DISPATCHER) > -1) {
          var button = (
            <Button
              style={{ position: "relative", left: "15px" }}
              bsStyle="danger"
              id="voidFormBRestriction"
              onClick={that.voidRestriction}
              disabled={that.state.batchMode}
            >
              Void Restriction
            </Button>
          );
        }
        return button;
      }
    }
    var content = (
      <div
        id="create-formCRestriction"
        className="content scaffold-create"
        role="main"
      >
        <form name="formCform" autoComplete="off">
          <fieldset className="form">
            <div id="controlLayoutGrid" className="container">
              <div className="row">
                {/*entire form row*/}
                <div className="gridRowPadding row">
                  <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                    <div className={"topRow"}>
                      <label>Multi-Sub</label>
                      <br />

                      <div
                        id="dropDown"
                        className="dropdown"
                        onClick={this.showSubDropDown}
                      >
                        <select
                          id="dropDownSelect"
                          style={
                            isReadOnly || disableSubSelection || isFieldUser
                              ? {
                                  width: "95px",
                                  cursor: "context-menu",
                                  backgroundColor: "rgb(235, 235, 228)",
                                }
                              : { width: "95px", cursor: "context-menu" }
                          }
                          title={
                            disableSubSelection
                              ? this.state.subSelectionTitle
                              : ""
                          }
                          disabled={
                            isReadOnly || disableSubSelection || isFieldUser
                          }
                          onMouseDown={this.handleMouseDown}
                        >
                          {/*<option selected="selected">{this.state.clickedItem}</option>*/}
                        </select>
                      </div>
                      <ul
                        id="dropDownUl"
                        onBlur={this.hideSubDropDown}
                        className="ulListDropdown"
                        style={{
                          float: "left",
                          visibility: this.state.showSubDropDown
                            ? "visible"
                            : "hidden",
                          padding: 0,
                          margin: 0,
                          width: "95px",
                          backgroundColor: "white",
                          listStyle: "none",
                          height: "400px",
                          overflowY: "auto",
                          zIndex: "99",
                          position: "absolute",
                        }}
                      >
                        {liItems}
                      </ul>
                    </div>
                    {fromMP}
                    {toMP}
                    {fromLocation}
                    {toLocation}
                    {authorizedBy}
                    {estimatedRemoval}
                  </div>
                  <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    {renderIssueButton(this)}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="gridRowPadding row">
                  <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10"></div>
                  <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    {voidRestricionButton(this)}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="gridRowPadding row">
                  <div className={"col-xs-5 col-sm-5 col-md-5 col-lg-5"}>
                    <label>
                      <input
                        type="checkbox"
                        disabled={isReadOnly || disableEntire || isFieldUser}
                        checked={this.state.entireSubChecked}
                        id="entireSubCheckBox"
                        name="entireSub"
                        title={disableEntire ? this.state.entireSubTitle : ""}
                        onChange={this.changeEntireSub}
                      />
                      SELECT ENTIRE SUB
                    </label>
                  </div>
                  <div className={"col-xs-5 col-sm-5 col-md-5 col-lg-5"}>
                    {selectAll}
                  </div>
                  <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}>
                    {renderResetButton(this)}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="gridRowPadding row">
                  <div
                    className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}
                    style={{ maxHeight: "40vh", overflowY: "auto" }}
                  >
                    <label>Multi Subdivisions:</label>
                    <br />
                    {renderChip}
                  </div>
                  <div className={"col-xs-5 col-sm-5 col-md-5 col-lg-5"}>
                    <label>*Text:</label>
                    <br />
                    <textarea
                      id="formCText"
                      rows={20}
                      disabled={isReadOnly || isFieldUser}
                      cols={Constants.MaxValues.MAX_PATTERN_LINE_LENGTH}
                      value={restrictionText}
                      onChange={this.changeText}
                      onBlur={this.onBlur}
                    />
                  </div>
                  <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2"}></div>
                  <div
                    className={"col-xs-3 col-sm-3 col-md-3 col-lg-3"}
                    style={{ paddingTop: "25px" }}
                  >
                    <div id="informationRadiatorOuterDivfc" className={infoRad}>
                      <InformationRadiatorView />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    );

    var formID = "formCform";

    if (!this.state.subdivisionSelected) {
      var style = {
        fontWeight: "bold",
        marginLeft: "10px",
        marginTop: "10px",
        fontSize: "x-large",
      };

      return <div style={style}>Please select a subdivision</div>;
    }
    //build up the form and bind the values
    return (
      <div id={formID}>
        {content}
        {<ModalError />}
      </div>
    );
  },
});

function determineValidRanges(subData) {
  if (
    subData &&
    subData.milePostRangeList &&
    subData.milePostRangeList.length > 0
  ) {
    var strings = subData.milePostRangeList.map(function (range) {
      return (
        range.from +
        (range.sfx ? range.sfx : "") +
        " to " +
        range.to +
        (range.sfx ? range.sfx : "")
      );
    });
    strings.splice(0, 0, "Valid Ranges:");
    return strings.join("\n");
  }
  return "No Ranges Found";
}

function sortFunction(c1, c2) {
  if (c1.lineNumber < c2.lineNumber) {
    return -1;
  }
  if (c1.lineNumber > c2.lineNumber) {
    return 1;
  }
  // a must be equal to b
  return 0;
}
